'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { full, success, disabledBg, pressed, cursor, borderWidth, container, borderColor } from "../Button.css.js";
import { getCssVariant } from "./getCssVariant.js";
import { hasBorder } from "./hasBorder.js";
function getButtonContainerClassNames(p) {
  const hasLowEmphasis = p.emphasis === "low" || p.emphasis === "lowCompact";
  const activeCursor = p.isSuccess ? "default" : "pointer";
  return classNames(
    p.className,
    container,
    hasBorder(p) ? borderWidth.regular : borderWidth.none,
    pickBorderColor(p),
    cursor[p.disabled ? "disabled" : activeCursor],
    p.pressed && pressed,
    p.disabled && !hasLowEmphasis && disabledBg[p.onDark ? "onDark" : "onLight"],
    p.isSuccess && success[p.onDark ? "onDark" : "onLight"],
    p.fullWidth && full,
    !p.disabled && !p.isSuccess && getCssVariant(p)[p.onDark ? "onDark" : "onLight"]
  );
}
function pickBorderColor(p) {
  const emphasisKey = p.onDark ? "emphasisDark" : "emphasis";
  return borderColor[p.disabled ? "subtle" : emphasisKey];
}
export {
  getButtonContainerClassNames
};
